import { useEffect, useRef, useState } from 'react';

import {
  ASYNC_RESOURCE_RELOAD_KEY,
  canReloadAsyncResource,
} from './async-resource-recovery';
import { reloadPage } from './navigation';

const useAsyncResourceRecovery = (error: unknown) => {
  const [recovering, setRecovering] = useState(() =>
    canReloadAsyncResource(error),
  );
  const attempted = useRef(false);

  useEffect(() => {
    if (!recovering || attempted.current) {
      return;
    }

    attempted.current = true;

    try {
      // Persist before navigation: the same failure after reload must not loop.
      if (sessionStorage.getItem(ASYNC_RESOURCE_RELOAD_KEY) !== null) {
        setRecovering(false);
        return;
      }

      sessionStorage.setItem(ASYNC_RESOURCE_RELOAD_KEY, '1');
      reloadPage();
    } catch {
      setRecovering(false);
    }
  }, [recovering]);

  return recovering;
};

export default useAsyncResourceRecovery;
